import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  infiniteKey: 1,
  store: {
    pageInfo: {
      page: 1,
      limit: 10,
      totalPage: 2
    },
    storeList: []
  },
  storeInfo: {},
  recommended: {
    pageInfo: {
      page: 1,
      totalPage: 2
    },
    recommendedStoreList: []
  },
  pageInfo: {},
  list: [],
  recentProducts: [],
  products: [],
  allProducts: [],
  productsPageInfo: {
    page: 1,
    totalPage: 2
  },
  storeCategoryNo: null,
  categoryProducts: []
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
